import { useTranslation } from "react-i18next";
import { OrderStatusEnum } from "../enums/orderStatus";
import { convertOrderStatusCodeToOrderStatusEnum } from "../utils/convertOrderStatusValue";

interface Props {
    code: number
}

const OrderStatus = ({ code }: Props) => {
    const { t } = useTranslation("global");
    const orderStatus = convertOrderStatusCodeToOrderStatusEnum(code);
    const convertOrderCodeToText = (): string => {
        switch (orderStatus) {
            case OrderStatusEnum.CURRENT_ORDER:
                return t("order_page.Current order");
            case OrderStatusEnum.To_Pack:
                return t("order_page.To pack");
            case OrderStatusEnum.To_Ship:
                return t("order_page.To ship");
            case OrderStatusEnum.Shipping:
                return t("order_page.Shipping");
            case OrderStatusEnum.Delivered:
                return t("order_page.Delivered");
            case OrderStatusEnum.Return:
                return t("order_page.Return");
            case OrderStatusEnum.Failed:
                return t("order_page.Failed");
            default:
                return orderStatus;
        }
    }

    return <span style={{
        lineHeight: 3,
        backgroundColor: 'rgba(255, 86, 48, 0.48)',
        borderRadius: "6px",
        padding: "2px 8px",

    }}>{convertOrderCodeToText()}</span>
}
export default OrderStatus;